export default __webpack_public_path__ + "static/media/ValuMass-440-Insertion.571c4452.png";